// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.StaticImage in staticImage/staticImage.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.sanitize
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Static image from device, this can be used to acquire image for testing or ROI.
 *
 * @property config Platform specific configuration encoded, this can be as base64 encoded.
 * @property imageBase64 Base64 encoded image
 */
public class StaticImage(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val config: String = "",
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "imageBase64",
    schemaIndex = 1,
  )
  public val image_base64: String = "",
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<StaticImage, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is StaticImage) return false
    if (unknownFields != other.unknownFields) return false
    if (config != other.config) return false
    if (image_base64 != other.image_base64) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + config.hashCode()
      result = result * 37 + image_base64.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """config=${sanitize(config)}"""
    result += """image_base64=${sanitize(image_base64)}"""
    return result.joinToString(prefix = "StaticImage{", separator = ", ", postfix = "}")
  }

  public fun copy(
    config: String = this.config,
    image_base64: String = this.image_base64,
    unknownFields: ByteString = this.unknownFields,
  ): StaticImage = StaticImage(config, image_base64, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<StaticImage> = object : ProtoAdapter<StaticImage>(
      FieldEncoding.LENGTH_DELIMITED, 
      StaticImage::class, 
      "type.googleapis.com/vreo.volt.protocol.StaticImage", 
      PROTO_3, 
      null, 
      "staticImage/staticImage.proto"
    ) {
      override fun encodedSize(`value`: StaticImage): Int {
        var size = value.unknownFields.size
        if (value.config != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(1, value.config)
        }
        if (value.image_base64 != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(2, value.image_base64)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: StaticImage) {
        if (value.config != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.config)
        }
        if (value.image_base64 != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 2, value.image_base64)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: StaticImage) {
        writer.writeBytes(value.unknownFields)
        if (value.image_base64 != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 2, value.image_base64)
        }
        if (value.config != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.config)
        }
      }

      override fun decode(reader: ProtoReader): StaticImage {
        var config: String = ""
        var image_base64: String = ""
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> config = ProtoAdapter.STRING.decode(reader)
            2 -> image_base64 = ProtoAdapter.STRING.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return StaticImage(
          config = config,
          image_base64 = image_base64,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: StaticImage): StaticImage = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
